module.exports = __webpack_public_path__ + "img/ban_facebook_auto_1121.3e2dbd6c.png";